import React from 'react';
import axios from 'axios';
import FilterData from './FilterData';

export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: [],
            additionalData: [],
            loader: false
        };

        this.fetchFiltersForReport = this.fetchFiltersForReport.bind(this);
        this.fetchAdditionalDataForReport = this.fetchAdditionalDataForReport.bind(this);
    }

    componentDidMount() {
        this.fetchLookups();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.fetchLookups();
        }
    }

    fetchLookups() {
        this.setState({
            loader: true
        });
        axios.all([this.fetchFiltersForReport(), this.fetchAdditionalDataForReport()])
            .then(axios.spread((filtersRes, additionalDataRes) => {
                let filters = filtersRes.data.sort((a, b) => a.orderNumber - b.orderNumber);
                this.setState({ filters, additionalData: additionalDataRes.data, loader: false });
            }))
            .catch(err => {
                console.log('Failed to fetch filters or additional data.');
            });
    }

    fetchFiltersForReport() {
        return axios.get(`/report/filters/${this.props.report}/`);
    }

    fetchAdditionalDataForReport() {
        return axios.get(`/report/additional-data/${this.props.report}/`);
    }

    render() {
        return (
            (!this.state.loader &&
                <FilterData
                    filters={this.state.filters}
                    additionalData={this.state.additionalData}
                    report={this.props.report}
                    reportTypeId={this.props.reportTypeId}
                    reportName={this.props.reportName}
                />)
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/Filters.js